// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'

import { Table } from '../../'
import { EmployerAPIAccessTableRow } from './EmployerAPIAccessTableRow'

export const EmployerAPIAccessTable = ({ api, employerAccessById, className }) => (
  <div className={className}>
    <Table
      columns={['employer', 'access', 'credentials']}
      rows={Object.entries(employerAccessById).map(([id, obj]) => (
        <EmployerAPIAccessTableRow
          api={api}
          employerId={id}
          employerObj={obj}
          key={`employerAccessTableRow_${id}`}/>
      ))}
      objectRows={true}
    />
  </div>
)

EmployerAPIAccessTable.propTypes = {
  api: PropTypes.string.isRequired,
  employerAccessById: PropTypes.shape({
    name: PropTypes.string.isRequired,
    access: PropTypes.bool.isRequired,
    key: PropTypes.string.isRequired
  }).isRequired,
  className: PropTypes.string
}

EmployerAPIAccessTable.defaultProps = {
  className: ''
}



// WEBPACK FOOTER //
// ./src/components/messageplus/employer-api-access-table/index.js